const state = () => ({
  selecionado: [],
  selecionado1: {},
  selecionado2: {},
  selecionado3: {}
});

const getters = {
  getSelecao: state => {
    return state.selecionado;
  }
};

const mutations = {
  SET_SELECAO(state, { selecao, id }) {
    state[`selecionado${id}`] = { ...state[`selecionado${id}`], ...selecao };
    state.selecionado = [state.selecionado1, state.selecionado2, state.selecionado3];
  },
  LIMPA_SELECAO(state) {
    state.selecionado1 = {};
    state.selecionado2 = {};
    state.selecionado3 = {};
  }
};

const actions = {
  setSelecao({ commit }, { selecao, id }) {
    commit("SET_SELECAO", { selecao, id });
  },
  setLimpaSelecao({ commit }) {
    commit("LIMPA_SELECAO");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
